import { NotificationsProps } from './notifications.types'
import { EntityType, NotificationType,  HeaderNotifications } from '@touche-lts/panel-ui/dist'
import {
  IconErrorSmall,
  IconInfoSmall,
  IconNotifications,
  IconSuccessSmall,
  IconWarningSmall
} from 'assets/icons'
import styles from './notifications.module.scss'
import cl from 'classnames'
import { useRootStore } from 'mobx-stores/store-provider'
import { observer } from 'mobx-react-lite'

const NotificationsComponent = (props: NotificationsProps) => {
  const { className } = props

  const {
    notificationsStore: {
      canbanNotifications,
      canbanNotificationsNew,
      deleteNotification
    }
  } = useRootStore()

  return (
    <HeaderNotifications
      className={cl(styles.container, className)}
      iconNotifications={IconNotifications}
      markNotificationSeen={(id: number) => deleteNotification(Number(id))}
      newNotificationsCount={canbanNotificationsNew.length}
      userNotificationsList={canbanNotifications as any}
      typeIcons={{
        ERROR: IconErrorSmall,
        INFO: IconInfoSmall,
        OK: IconSuccessSmall,
        WARNING: IconWarningSmall
      }} 
    />
  )
}

const Notifications = observer(NotificationsComponent)
export { Notifications }
